// Version : 1.0.0
// Author : AGALYA
import CurrentAddressActionType from './current-address.types';

/** ***************** CURRENT ADDRESS DATA START *********************** */
export const currentAddressDataStart = (saveData: any) => ({
	type: CurrentAddressActionType.CURRENT_ADDRESS_ADD_CHANGED,
	payload: saveData,
});

export const currentAddressAddStart = (currentAddressCredentials: any) => ({
	type: CurrentAddressActionType.CURRENT_ADDRESS_ADD_START,
	payload: currentAddressCredentials,
});

export const currentAddressAddSuccess = (currentAddressSuccess: any) => ({
	type: CurrentAddressActionType.CURRENT_ADDRESS_ADD_SUCCESS,
	payload: currentAddressSuccess,
});

export const currentAddressAddFailure = (currentAddressFailure: unknown) => ({
	type: CurrentAddressActionType.CURRENT_ADDRESS_ADD_FAILURE,
	payload: currentAddressFailure,
});

export const currentAddressAddResponseResetStart = () => ({
	type: CurrentAddressActionType.CURRENT_ADDRESS_ADD_RESPONSE_REST_START,
});

export const currentAddressAddUserResponseChanged = () => ({
	type: CurrentAddressActionType.CURRENT_ADDRESS_ADD_RESPONSE_CHANGED,
});
/** ***************** CURRENT ADDRESS DATA END *********************** */
